import * as React from "react";
import type { SVGProps } from "react";

interface ScoreProps extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const Score = ({ cancelled = false, ...props }: ScoreProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    {...props}
  >
    <g>
    <g fill="none" fillRule="nonzero">
      <path
        fill="#FFF"
        d="M16.903 1.343c1.764 1.19 2.294 3.56 1.115 5.308-.32.473-.727.839-1.198 1.077l-.066.03-.58.86-1.88 10.695-.57.416c-.77.562-1.338.829-2.149.67a3.3 3.3 0 0 1-1.097-.44l-.155-.103-.089.017c-.354.06-.653.068-.95.017l-.148-.03c-.525-.127-1.015-.389-1.491-.771l-.026-.023c-.69-.037-1.31-.201-1.85-.515l-.2-.124a3.8 3.8 0 0 1-1.11-1.18l-.136-.242L4.305 17c-.49-.2-.898-.466-1.219-.828l-.132-.162a2.9 2.9 0 0 1-.554-1.361l-.006-.048-.119-.084c-.423-.31-.76-.622-1.016-.953l-.121-.167c-.61-.897-.432-1.811.111-2.701l.214-.351 9.023-5.685.524-.776.003-.071c.04-.46.187-.912.437-1.336l.114-.18C12.743.55 15.138.154 16.903 1.344"
      />
      <path
        fill="#000"
        d="M15.536 7.917 11.28 5.046l-9.268 5.839-.123.2c-.405.665-.53 1.303-.13 1.89l.1.137c.249.319.608.633 1.084.957l.168.11c.025.553.161 1.009.44 1.377l.11.131c.267.295.632.514 1.092.68l.11.036.09.189c.26.512.603.92 1.036 1.213l.174.108c.477.27 1.045.402 1.696.411l.044-.001.057.052c.449.39.893.645 1.351.755l.116.023c.23.035.49.017.816-.047l.256-.058.08.068c.364.283.741.47 1.14.547.527.103.963-.101 1.563-.54l.325-.237zm-1.097.466-1.747 9.933q-.561.409-.78.366-.543-.107-1.135-.743-.968.282-1.232.219-.562-.136-1.255-.847-1.122.084-1.742-.335t-.93-1.4q-.963-.219-1.27-.624-.306-.405-.224-1.32-1.18-.691-1.539-1.219-.176-.26.158-.807l8.519-5.366z"
      />
      <path
        fill="#000"
        d="m14.705 7.565-1.05 3.198.233.078.713.23-.246.772-.386-.123a26 26 0 0 1-.566-.188l-2.306 7.038-.95-.312 2.318-7.075a14 14 0 0 1-.344-.144L8.6 18.221l-.898-.44 3.522-7.184a6 6 0 0 1-.577-.37l-4.99 6.148-.777-.63 5.002-6.162a14 14 0 0 1-.354-.343l-5.426 5.098-.685-.728L8.84 8.512q-.148-.165-.303-.343l-.488-.572.618-.524.262.308q.259.306.502.577l2.306-2.17.655.697.06-.075.76.615.53.26.012-.031zm-2.139.293-1.408 1.738a5 5 0 0 0 .422.272zm-.372-1.127-2.076 1.953q.141.142.275.269zm1.11 1.895-.826 1.685.24.101z"
      />
      <path
        fill="#000"
        d="m17.034 6.002-4.5-3.035-1.866 2.765.432.57q.698.925 1.478 1.453.781.525 1.9.826l.69.187z"
      />
      <path
        fill="#FFF"
        d="m15.646 6.272-.907 1.344q-.968-.262-1.602-.69t-1.24-1.227l.906-1.344z"
      />
      <path
        fill="#000"
        d="M16.483 1.965c-1.429-.964-3.356-.645-4.297.751-.952 1.411-.314 2.828 1.196 3.847 1.51 1.018 3.063 1.079 4.015-.332.941-1.396.515-3.302-.914-4.266"
      />
      <path
        fill="#FFF"
        d="M15.924 2.794c.981.662 1.27 1.95.644 2.878s-1.646.724-2.627.062-1.552-1.53-.926-2.459c.625-.927 1.928-1.143 2.909-.48M16.25 8.5a7.75 7.75 0 1 0 0 15.5 7.75 7.75 0 0 0 0-15.5"
      />
      <path fill="#007BBD" d="M16.25 9.25a7 7 0 1 1 0 14 7 7 0 0 1 0-14" />
      <path
        fill="#FFF"
        d="M19.32 20.25q-.648 0-.648-.708v-6.06l-.864.564q-.6.408-.936-.144-.348-.552.252-.924l1.44-.9q.216-.132.42-.186t.468-.054q.504 0 .504.708v6.996q0 .708-.636.708M14.083 14.583c.26 0 .47.224.47.5l-.002 1.531h1.532c.276 0 .5.21.5.47 0 .258-.224.468-.5.468h-1.532l.001 1.531c0 .276-.21.5-.469.5s-.468-.224-.468-.5v-1.532l-1.532.001c-.276 0-.5-.21-.5-.469s.224-.468.5-.468h1.531v-1.532c0-.276.21-.5.47-.5"
      />
    </g>
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default Score;
